<div id="viewMode">
    <form [formGroup]="viewModeForm">
        Show:
        <input type="radio" id="radMap" value="map" name="viewMode" formControlName="viewMode" (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radMap">Map</label>    
        <input type="radio" id="radTable" value="table" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radTable">Table</label>    
        <input type="radio" id="radBoth" value="both" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" checked="checked" /><label class="ml-2" for="radBoth">Both</label>
    </form>
</div>
<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="flex-grow-1">
  <div class="row summary-row">
    <div class="col-12">
        <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
    </div>
  </div>
  <div class="row flex-grow-1">
    <div  [ngClass]="{'col-md-5 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'table', 'col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'map' }">
        <div class="card-header map-card-header mb-1">
            <ng-container *ngFor="let type of locationTypesDisplay">
              <div class="pr-2" *ngIf="type.name != 'Depot' && type.name != 'Under Investigation'">
                <div class="icon-circle icon-circle-xs map-legend dot" [ngStyle]="{'background-color': type.colour}"></div>
                {{ type.name }}
              </div>
            </ng-container>
          </div>
          <div appSetHeight class="map">
            <div class="map-container">
              <div class="map-frame" #mapdiv>
                <div id="map"></div>
              </div>
            </div>
          </div>
    </div>
    <div [ngClass]="{'col-md-7 col-12 pl-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'map', 'col-md-12 col-12 pl-1 flex-grow-1 d-flex flex-column pt-4' : showMode === 'table' }">
      <div id="filters" class="row pt-2">
        <div class="col-12">
            <mat-form-field appearance="fill" [hidden]="!regionList || regionList.length == 0" style="width: 15%">
                <mat-label>Region</mat-label>
                <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let region of regionList" [value]="region.id">{{region.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 20%">
                <mat-label>Depot</mat-label>
                <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let depot of depotList" [value]="depot.id">{{depot.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 36%">
                <mat-label>Location</mat-label>
                <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)">
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let location of locationList" [value]="location.id">{{location.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 12%">
                <mat-label>Show</mat-label>
                <mat-select [(value)]="selectedShowSetting" (selectionChange)="showSettingChange($event.value)">
                    <mat-option>All</mat-option>
                    <mat-option value={{ShowSetting[ShowSetting.Surplus]}}>Surplus</mat-option>
                    <mat-option value={{ShowSetting[ShowSetting.Deficit]}}>Deficit</mat-option>
                </mat-select>
            </mat-form-field>      
<!--             <mat-form-field appearance="fill" style="width: 20%" hidden>
                <mat-label>Status</mat-label>
                <mat-select [(value)]="selectedDamageStatus" (selectionChange)="damageStatusChange($event.value)">
                    <mat-option>None</mat-option>
                    <mat-option value={{DamageStatus[DamageStatus.InService]}}>In Service</mat-option>
                    <mat-option value={{DamageStatus[DamageStatus.Damaged]}}>Damaged</mat-option>
                    <mat-option value={{DamageStatus[DamageStatus.DamagedInService]}}>Damaged In Service</mat-option>
                </mat-select>
            </mat-form-field> -->
            <mat-form-field appearance="fill" style="width: 15%">
                <mat-label>Compare</mat-label>
                <input matInput [formControl]="compareDate" [matDatepicker]="picker" (dateChange)="dateFilterChanged($event.value)" [min]="getMinCompareDate()" [max]="getMaxCompareDate()">
                <mat-datepicker-toggle matSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>                  
          </div>
      </div>
      <div appSetHeight class="col-12 pl-0 pr-0 flex-grow-1">
        <div class="h-100 overflow-auto">
            <div *ngIf="data?.depotAvailability?.roros?.length || data?.depotAvailability?.skips?.length" class="col-12 summary pl-0">
                <div id="report">
                    <ng-container>
                        <div id="roros" *ngIf="data?.depotAvailability?.roros?.length && selectedVehicleType != 'Chain Lift'">
                            <h5>RoRo</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="region-group">
                                    </th>
                                    <ng-container *ngFor="let depot of data.depotAvailability.roros[0].depots">
                                        <th class="empty">
                                        </th>
                                        <th class="depot" colspan="2">
                                            {{ depot.name }}
                                        </th>                                     
                                    </ng-container>
                                </tr>
                                <tr>
                                    <th class="region-group">
                                    </th>
                                    <ng-container *ngFor="let depot of data.depotAvailability.roros[0].depots">
                                        <th class="empty">
                                        </th>
                                        <th class="region-type">
                                            AVAILABLE
                                        </th>
                                        <th class="region-type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>
                                    </ng-container>
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.depotAvailability.roros">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.depots[0]?.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.depots[0]?.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div>
                                            </td>
                                            <ng-container *ngFor="let depot of group.depots">
                                                <td></td>
                                                <td class="column">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ depot.availableCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': depot.compareAvailableCountColor}">{{ depot.compareAvailableCountDisplay }}</span>
                                                    </div>
                                                </td>
                                                <td class="column">
                                                    <div class="innerWrapper">
                                                        <span class="default" [ngStyle]="{'color': depot.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ depot.netSurplusCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': depot.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ depot.compareNetSurplusCountDisplay }}</span>
                                                    </div>
                                                </td>
                                            </ng-container>
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                            <ng-container *ngFor="let row of group.depots[0].assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ row.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <ng-container *ngFor="let depot of group.depots">
                                                        <td></td>
                                                        <td class="default">
                                                            <div class="innerWrapper">
                                                                <span class="default">{{ getAssetType(depot.assetTypes, row.name)?.availableCount }}</span>
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.compareAvailableCountColor}">{{ getAssetType(depot.assetTypes, row.name)?.compareAvailableCountDisplay }}</span>
                                                            </div> 
                                                        </td>
                                                        <td class="default">
                                                            <div class="innerWrapper">
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ getAssetType(depot.assetTypes, row.name)?.netSurplusCount }}</span>
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ getAssetType(depot.assetTypes, row.name)?.compareNetSurplusCountDisplay }}</span>
                                                            </div> 
                                                        </td>
                                                    </ng-container>
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="skips" *ngIf="data?.depotAvailability?.skips?.length && selectedVehicleType != 'RoRo'">
                            <h5>Skip</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="region-group">
                                    </th>
                                    <ng-container *ngFor="let depot of data.depotAvailability.skips[0].depots">
                                        <th class="empty">
                                        </th>
                                        <th class="depot" colspan="2">
                                            {{ depot.name }}
                                        </th>                                     
                                    </ng-container>
                                </tr>
                                <tr>
                                    <th class="region-group">
                                    </th>
                                    <ng-container *ngFor="let depot of data.depotAvailability.skips[0].depots">
                                        <th class="empty">
                                        </th>
                                        <th class="region-type">
                                            AVAILABLE
                                        </th>
                                        <th class="region-type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>
                                    </ng-container>
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.depotAvailability.skips">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.depots[0]?.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.depots[0]?.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div>
                                            </td>
                                            <ng-container *ngFor="let depot of group.depots">
                                                <td></td>
                                                <td class="column">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ depot.availableCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': depot.compareAvailableCountColor}">{{ depot.compareAvailableCountDisplay }}</span>
                                                    </div>
                                                </td>
                                                <td class="column">
                                                    <div class="innerWrapper">
                                                        <span class="default" [ngStyle]="{'color': depot.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ depot.netSurplusCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': depot.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ depot.compareNetSurplusCountDisplay }}</span>
                                                    </div>
                                                </td>
                                            </ng-container>
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                            <ng-container *ngFor="let row of group.depots[0].assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ row.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <ng-container *ngFor="let depot of group.depots">
                                                        <td></td>
                                                        <td class="default">
                                                            <div class="innerWrapper">
                                                                <span class="default">{{ getAssetType(depot.assetTypes, row.name)?.availableCount }}</span>
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.compareAvailableCountColor}">{{ getAssetType(depot.assetTypes, row.name)?.compareAvailableCountDisplay }}</span>
                                                            </div> 
                                                        </td>
                                                        <td class="default">
                                                            <div class="innerWrapper">
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ getAssetType(depot.assetTypes, row.name)?.netSurplusCount }}</span>
                                                                <span class="default" [ngStyle]="{'color': getAssetType(depot.assetTypes, row.name)?.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ getAssetType(depot.assetTypes, row.name)?.compareNetSurplusCountDisplay }}</span>
                                                            </div> 
                                                        </td>
                                                    </ng-container>
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="!data?.depotAvailability?.roros?.length && !data?.depotAvailability?.skips?.length" class="col-12 summary pl-0">
                <div id="report">
                    <div id="roros" *ngIf="data?.roros && data.roros.length > 0 && selectedVehicleType != 'Chain Lift'">
                        <h5>RoRo</h5>
                        <table class='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                            <tr>
                                <th class="group">
                                </th>
                                <th class="type">
                                    DEPOT
                                </th>
                                <th class="type">
                                    YARD
                                </th>
                                <th class="type">
                                    DAMAGED
                                </th>
                                <th class="type">
                                    AVAILABLE
                                </th>
                                <th class="type">
                                    USAGE
                                </th>
                                <th class="type">
                                    ADJUST
                                </th>
                                <th class="type">
                                    <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                </th>
                                <th class="type">
                                    <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                </th>
<!--                                 <th class="type">
                                    <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                </th>
                                <th class="type">
                                    <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                </th> -->
                            </tr>
                            </thead>
                            <tbody class="dummy">
                            <tr>
                                <td class="h-2" colspan="12"></td>
                            </tr>
                            </tbody>
                            <tbody>
                                <ng-container *ngFor="let group of data.roros">
                                    <tr>
                                        <td class="category">
                                            <div class="innerWrapper">
                                                <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                <span class="reference">{{ group.name }}</span>
                                            </div> 
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.depotCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareDepotCountColor}">{{ group.compareDepotCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.yardCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareYardCountColor}">{{ group.compareYardCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.damagedCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareDamagedCountColor}">{{ group.compareDamagedCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.availableCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareAvailableCountColor}">{{ group.compareAvailableCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.requiredCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareRequiredCountColor}">{{ group.compareRequiredCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.adjustCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareAdjustCountColor}">{{ group.compareAdjustCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareNetRequiredCountColor}" *ngIf="!this.selectedDamageStatus">{{ group.compareNetRequiredCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" [ngStyle]="{'color': group.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ group.compareNetSurplusCountDisplay }}</span>
                                            </div>
                                        </td>
<!--                                         <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td>
                                        <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td> -->
                                    </tr>
                                    <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                        <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                        <ng-container *ngFor="let assetType of group.assetTypes">
                                            <tr>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">{{ assetType.name }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.depotCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareDepotCountColor}">{{ assetType.compareDepotCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.yardCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareYardCountColor}">{{ assetType.compareYardCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.damagedCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareDamagedCountColor}">{{ assetType.compareDamagedCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.availableCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareAvailableCountColor}">{{ assetType.compareAvailableCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.requiredCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareRequiredCountColor}">{{ assetType.compareRequiredCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.adjustCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareAdjustCountColor}">{{ assetType.compareAdjustCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareNetRequiredCountColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.compareNetRequiredCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default" [ngStyle]="{'color': assetType.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.compareNetSurplusCountDisplay }}</span>
                                                    </div> 
                                                </td>
<!--                                                 <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                    </div> 
                                                </td> -->
                                            </tr>
                                        </ng-container>
                                        <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div id="skips" *ngIf="data?.skips && data.skips.length > 0 && selectedVehicleType != 'RoRo'">
                        <h5>Skip</h5>
                        <table class='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                                <tr>
                                    <th class="group">
                                    </th>
                                    <th class="type">
                                        DEPOT
                                    </th>
                                    <th class="type">
                                        YARD
                                    </th>
                                    <th class="type">
                                        DAMAGED
                                    </th>
                                    <th class="type">
                                        AVAILABLE
                                    </th>
                                    <th class="type">
                                        USAGE
                                    </th>
                                    <th class="type">
                                        ADJUST
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                    </th>
<!--                                     <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody class="dummy">
                            <tr>
                                <td class="h-2" colspan="12"></td>
                            </tr>
                            </tbody>
                            <tbody>
                                <ng-container *ngFor="let group of data.skips">
                                    <tr>
                                        <td class="category">
                                            <div class="innerWrapper">
                                                <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                <span class="reference">{{ group.name }}</span>
                                            </div> 
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.depotCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareDepotCountColor}">{{ group.compareDepotCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.yardCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareYardCountColor}">{{ group.compareYardCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.damagedCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareDamagedCountColor}">{{ group.compareDamagedCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.availableCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareAvailableCountColor}">{{ group.compareAvailableCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.requiredCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareRequiredCountColor}">{{ group.compareRequiredCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.adjustCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareAdjustCountColor}">{{ group.compareAdjustCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareNetRequiredCountColor}" *ngIf="!this.selectedDamageStatus">{{ group.compareNetRequiredCountDisplay }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" [ngStyle]="{'color': group.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                <span class="default" [ngStyle]="{'color': group.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ group.compareNetSurplusCountDisplay }}</span>
                                            </div>
                                        </td>
<!--                                         <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td>
                                        <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td> -->
                                    </tr>
                                    <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                        <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                        <ng-container *ngFor="let assetType of group.assetTypes">
                                            <tr>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">{{ assetType.name }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.depotCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareDepotCountColor}">{{ assetType.compareDepotCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.yardCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareYardCountColor}">{{ assetType.compareYardCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.damagedCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareDamagedCountColor}">{{ assetType.compareDamagedCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.availableCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareAvailableCountColor}">{{ assetType.compareAvailableCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.requiredCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareRequiredCountColor}">{{ assetType.compareRequiredCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ assetType.adjustCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareAdjustCountColor}">{{ assetType.compareAdjustCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareNetRequiredCountColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.compareNetRequiredCountDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="default" [ngStyle]="{'color': assetType.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        <span class="default" [ngStyle]="{'color': assetType.compareNetSurplusCountColor}" *ngIf="!this.selectedDamageStatus">{{ assetType.compareNetSurplusCountDisplay }}</span>
                                                    </div> 
                                                </td>
<!--                                                 <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                    </div> 
                                                </td>
                                                <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                    <div class="innerWrapper">
                                                        <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                    </div> 
                                                </td> -->
                                            </tr>
                                        </ng-container>
                                        <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><!-- <td></td><td></td> --></tr>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div id="others" *ngIf="data?.others && data.others.length > 0" hidden>
                        <h5>Ungrouped</h5>
                        <table class='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                                <tr>
                                    <th class="group">
                                    </th>
                                    <th class="type">
                                        DEPOT
                                    </th>
                                    <th class="type">
                                        YARD
                                    </th>
                                    <th class="type">
                                        DAMAGED
                                    </th>
                                    <th class="type">
                                        AVAILABLE
                                    </th>
                                    <th class="type">
                                        USAGE
                                    </th>
                                    <th class="type">
                                        ADJUST
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                    </th>
<!--                                     <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody class="dummy">
                            <tr>
                                <td class="h-2" colspan="12"></td>
                            </tr>
                            </tbody>
                            <tbody>
                                <ng-container *ngFor="let group of data.others">
                                    <tr>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.depotCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.yardCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.damagedCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.availableCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.requiredCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default">{{ group.adjustCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                            </div>
                                        </td>
                                        <td class="column">
                                            <div class="innerWrapper">
                                                <span class="default" [ngStyle]="{'color': group.netSurplusColor}" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                            </div>
                                        </td>
<!--                                         <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td>
                                        <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                            <div class="innerWrapper">
                                                <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                            </div> 
                                        </td> -->
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>